import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as Routes from 'modules/routes';

interface JobStatusData {
  status: 'enqueued' | 'processing' | 'completed' | 'failed' | 'not_found';
  user_id?: number;
  user_type?: string;
  created_at?: string;
  metadata?: Record<string, unknown>;
}

interface JobStatusResponse {
  data: JobStatusData;
}

interface UseJobStatusOptions {
  jobId: string | null;
  enabled?: boolean;
  refetchInterval?: number | false;
  onSuccess?: (data: JobStatusData) => void;
  onError?: (error: Error) => void;
}

export default function useJobStatus({
  jobId,
  enabled = true,
  refetchInterval = false,
  onSuccess,
  onError,
}: UseJobStatusOptions) {
  return useQuery<JobStatusData, Error>({
    enabled: enabled && !!jobId,
    onError,
    onSuccess,
    queryFn: async () => {
      if (!jobId) {
        throw new Error('Job ID is required');
      }

      const response = await axios.get<JobStatusResponse>(Routes.plato_api_job_status_path(jobId));
      return response.data.data;
    },
    queryKey: ['jobStatus', jobId],
    refetchInterval,
    retry: false,
  });
}
